import React from 'react';

/**
 * Wordpress Embed Layout
 *
 * @param {object} props
 *                  {Ref} anchor    useRef hook
 * @returns
 */
const WordpressEmbedLayout = ({ anchor, children }) => {
  return (
    <div ref={anchor}>
      {children}
    </div>
  );
}

export default WordpressEmbedLayout;